export enum DrupalTypes {
  center = 'node--centre_de_prelevement',
  file = 'file--file',
  service = 'taxonomy_term--services',
}
